import { TRADIFY_FORM_URL } from "@/siteConfig";

export default function TradifyForm({ testid = "tradify-form", className = "" }) {
  return (
    <div data-testid={testid} className={`overflow-hidden rounded-2xl border border-line bg-white ${className}`}>
      <iframe
        src={TRADIFY_FORM_URL}
        title="Modify enquiry form"
        loading="lazy"
        className="block w-full border-0"
        style={{ height: "1050px", margin: 0, padding: 0 }}
      />
    </div>
  );
}
